import { combineReducers } from 'redux'
import repository from './repository'
export default combineReducers({
  repository
})



// WEBPACK FOOTER //
// ./src/reducers/index.js